import * as React from 'react';

const Image = (props) => {
    return (<img className={props.class} src={`images/${props.image}`} alt={props.alt} />);
}

export default Image;